<template>
  <div>
    <UkrposhtaHead
            :countFilterParams="countFilterParams"
            :showFilter="showFilter"
            @toggleFilter="toggleFilter"
            @createGroupF103A="$emit('createGroupF103A')"
            @filter="$emit('filter')"
            @reload="$emit('reload')"
            @selectAll="selectAll"
    />

    <div class="table-filter-wrap">

      <UkrposhtaFilter
              :showFilter="showFilter"
              :filterGetParams="filterGetParams"
              @close="closeFilter"
              @changeFilter="data => $emit('changeFilter', data)"
              @resetFilter="$emit('resetFilter')"
      />

      <UkrposhtaTable
              :selectedNow="selectedNow"
              :countFilterParams="countFilterParams"
              @showMore="$emit('showMore')"
              @resetFilter="$emit('resetFilter')"
              @updateTable="$emit('updateTable')"
              @reload="$emit('reload')"
      />
    </div>
  </div>
</template>

<script>


  import UkrposhtaHead from "./UkrposhtaHead/UkrposhtaHead";
  import UkrposhtaFilter from "./UkrposhtaFilter/UkrposhtaFilter";
  import UkrposhtaTable from "./UkrposhtaTable/UkrposhtaTable";

  export default {
    name: "UkrposhtaTableUser",

    components: {
      UkrposhtaHead,
      UkrposhtaFilter,
      UkrposhtaTable,
    },

    props: {
      countFilterParams: Number,
      filterGetParams: Object,
    },

    data(){
      return{
        showFilter: false,
        selectedNow: false,
      }
    },

    methods: {
      closeFilter() {
        this.showFilter = false
      },

      toggleFilter() {
        this.showFilter = !this.showFilter
      },

      selectAll(val) {
        this.selectedNow = val
      },
    }
  }
</script>

<style scoped>

</style>
